import { FacetRenderer } from "../rendering/renderable/Renderable";
import { AudioSourceFacet } from "flavr-common";
import { PositionalAudio, AudioLoader } from "three";
import { camera } from "../rendering/camera";
const audioLoader = new AudioLoader();
export class AudioSourceRenderable extends FacetRenderer {
    constructor(owner) {
        super(owner);
        this.owner = owner;
        this.url = "";
        this.sound = new PositionalAudio(camera.audioListener);
        this.sound.matrixAutoUpdate = false;
        this.sound.frustumCulled = false;
        this.sound.setDistanceModel("linear");
        this.sound.setLoop(true);
        this.owner.renderer.addToScene(this.sound, this.owner.modelUID);
    }
    destroy() {
        if (this.sound.isPlaying) {
            this.sound.stop();
        }
        this.owner.renderer.removeFromScene(this.sound, this.owner.modelUID);
    }
    setVisible(visible) {
        if (visible) {
            if (!this.sound.isPlaying && this.sound.sourceType === "buffer") {
                this.sound.play();
            }
        }
        else {
            this.sound.pause();
        }
    }
    updateFacet(facet) {
        if (facet.params) {
            facet.params.volume !== undefined && this.sound.setVolume(facet.params.volume);
            facet.params.refDistance !== undefined && this.sound.setRefDistance(facet.params.refDistance);
            facet.params.rolloffFactor !== undefined && this.sound.setRolloffFactor(facet.params.rolloffFactor);
            facet.params.maxDistance !== undefined && this.sound.setMaxDistance(facet.params.maxDistance);
        }
        if (this.url !== facet.audioUrl) {
            this.url = facet.audioUrl;
            audioLoader.load(facet.audioUrl, (buffer) => {
                this.sound.setBuffer(buffer);
                if (this.owner.isFacetVisible(AudioSourceFacet.typestatic) && this.owner.isModelInCurrentRoom()) {
                    this.sound.play();
                }
            }, () => { }, () => {
                console.warn(`[audio] Can't load Audio ${facet.audioUrl}`);
            });
        }
    }
    updateTransform() {
        this.sound.matrix.copy(this.owner.matrixWorld);
        this.sound.updateMatrixWorld(true);
    }
}
